import { useCallback, useContext } from 'react'
import { UserContext } from '../user/UserContext'
import { Machine } from './Machine'

export const useFinancingData = () => {
  const { user } = useContext(UserContext)

  const getFinancingData = useCallback(
    (machine: Machine) =>
      user.countryCode ? (machine.financing[user.countryCode] ?? null) : null,
    [user.countryCode]
  )

  return { getFinancingData }
}
